export default __webpack_public_path__ + "static/media/ninninger.29307aee.png";